import { types, getRoot } from 'mobx-state-tree';
import PromiseController from 'react-modal-promise';
import { IRootStore } from './root';

const DialogStore = types
    .model({})
    .volatile((self) => ({
        refModalFactory: {} as PromiseController | null,
        modals: new Map<string, Function>(),
    }))
    .views((self) => ({
        get root(): IRootStore {
            return getRoot<IRootStore>(self);
        },
    }))
    .actions((self) => ({
        registerRef(node: PromiseController) {
            self.refModalFactory = node;
        },
        registerModal(key: string, modal: Function) {
            self.modals.set(key, modal);
        },
        async open(key: string, { closeAll = false, ...props }: any = {}) {
            const modal = self.modals.get(key);
            if (!modal) throw new Error(`The '${key}' modal is not registered`);
            if (self.refModalFactory?.hasInstance(key)) return; // throw new Error(`The '${key}' modal is already opened`);

            if (closeAll) self.refModalFactory?.resolveAll();
            return modal({ instanceId: key, ...props });
        },
        close(key: string, val: any = 0) {
            self.refModalFactory?.resolve(key, val);
        },
        closeAll() {
            self.refModalFactory?.resolveAll();
        },
        async error({
            title = 'Error',
            message /** error code or traslate id */,
            errorData = {},
            confirmText,
            cancelText,
        }: {
            title?: string;
            message: string | number;
            errorData?: any;
            confirmText?: string;
            cancelText?: string;
        }) {
            const errorModal = self.modals.get('error');
            if (!errorModal) throw new Error('Error modal is not registered');
            const key = `error-${message}`;
            if (self.refModalFactory?.hasInstance(key)) throw new Error(`${key} modal is already opened`);

            return errorModal({ instanceId: key, title, message, errorData, confirmText, cancelText });
        },
    }));

export default DialogStore;
